export const site = {
  name: "日韩中文字幕在线观看",
  shortName: "日韩字幕站",
  slogan: "海量日韩影视剧在线播放",
  description:
    "日韩中文字幕在线观看为您提供丰富的日韩影视剧资源，涵盖最新电视剧和电影，带中文字幕，便于观看和理解，支持多样分类浏览。",
  keywords:
    "日韩中文字幕在线观看,日韩影视,中文字幕影视,日韩电视剧,日韩电影,在线影视,影视在线播放,日韩剧字幕",
  email: "support@jksubtitles.example.com",
};